/**
 * Generate SEO-friendly URL slugs and listing URLs
 */

// Generate a URL-friendly slug from text
export function generateSlug(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')  // Remove special characters
    .replace(/[\s_]+/g, '-')       // Replace whitespace with hyphens
    .replace(/-+/g, '-')           // Remove multiple hyphens
    .replace(/^-|-$/g, '');        // Remove leading/trailing hyphens
}

// Generate the SEO-friendly listing URL for a property
// Format: /api/listings/{city-slug}/{title-slug}-{short-id}
// Note: Uses /api/ prefix to ensure routing to backend SSR
export function getListingUrl(property) {
  if (!property || !property.id) return '/';
  
  const citySlug = property.city_id || 'florida';
  const titleSlug = generateSlug(property.title || 'property');
  const shortId = property.id.substring(0, 8);
  
  return `/api/listings/${citySlug}/${titleSlug}-${shortId}`;
}

// For backward compatibility with existing /listing/:id routes
// These will be handled by the React app
export function getLegacyListingUrl(propertyId) {
  return `/listing/${propertyId}`;
}
